const WIX_FORMS_APP_DEF_ID = '14ce1214-b278-a7e4-1373-00cebd1bef7c';
const ASCEND_APP_DEF_IDS = [WIX_FORMS_APP_DEF_ID];

export default {
  isAscendUpgrade(appDefinitionId: string) {
    return ASCEND_APP_DEF_IDS.includes(appDefinitionId);
  },
};
